import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { approach } from 'src/app/core/translations/approach';
import { SeoService } from 'src/app/seo.service';
import { environment } from 'src/environments/environment';
import { REQUEST } from '@nguniversal/express-engine/tokens';
@Component({
  selector: 'app-approach',
  templateUrl: './approach.component.html',
  styleUrls: ['./approach.component.scss'],
})
export class ApproachComponent implements OnInit {
  isHandsetPortrait: boolean = false;

  bannerImage: any ='';
  bannerClass: any ='';

  currentLanguage: string = '';
  languageTranslations: any = approach;
  activeLanguageTranslations: any = {};
  constructor(private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    
    this.bannerClass = environment.pageClass;
    this.bannerImage = environment.staticPageBanner;
   

    if (this.route.snapshot.paramMap.get('language')) {
      let language: string | null =
        this.route.snapshot.paramMap.get('language');

      if (language) {
        this.activeLanguageTranslations = this.languageTranslations[language];
      }
    }
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }
}
